/* @flow */

import React, { useContext } from "react";
import type { Block } from "components/Category";
import { useData } from "crustate/react";
import { HomeData } from "data";
import { StoreInfoContext } from "entrypoint/shared";
import Category from "components/Category";
import { MobileOnlyCarousel } from "@crossroads/shop-views/";
import { useTranslate } from "@awardit/react-use-translate";
import cn from "classnames";

import styles from "./styles.scss";

type Props = {
  useWrapper?: boolean,
};

const getCategoriesData = (
  homeData: { [string]: any },
  locale: string
): Array<Block> => {
  if (homeData == null) {
    return [];
  }

  const categories = (Object.values(homeData): Array<any>)
    .filter(entry => entry && Object.prototype.hasOwnProperty.call(entry, "carousel"))
    .map((entry: { carousel: Block }) => ({
      name: entry.carousel.name,
      url: entry.carousel.url,
      image: entry.carousel.image,
    }))
    .filter(item => item.name && item.url);

  if (locale === "en_GB") {
    return categories.filter(item => item.url !== "/gift-cards-vouchers");
  }

  return categories;
};

const CategorySection = ({ useWrapper = false }: Props): React$Node => {
  const home = useData(HomeData);
  const t = useTranslate();
  const { info } = useContext(StoreInfoContext);

  if (home.state !== "LOADED") {
    return null;
  }

  const items = getCategoriesData(home.data, info.locale);

  if (items.length === 0) {
    return null;
  }

  if (useWrapper) {
    return (
      <div className={styles.wrapper}>
        <h2 className={cn("h3", styles.sectionTitle)}>{t("HOMEVIEW.POPULAR_CATEGORIES")}</h2>
        <MobileOnlyCarousel
          items={items}
          ItemComponent={Category}
          getItemKey={item => item.url}
          desktopSlidesToShow={6}
        />
      </div>
    );
  }

  return (
    <MobileOnlyCarousel
      items={items}
      ItemComponent={Category}
      getItemKey={item => item.url}
      desktopSlidesToShow={6}
    />
  );
};

export default CategorySection;
